import React from "react";
import FundDetails from "../../features/icfunddetails";

const FundDetailsPage = () => <FundDetails />

export default FundDetailsPage;